module.exports = {
      id: "icon-star-usage",
      viewBox: "0 0 30.754 29.435",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#icon-star",
      toString: function () {
        return this.url;
      }
    }